module.exports = __webpack_public_path__ + "graphics/blue-tick.ckh.5813b69918e0f6506519d0f6371a0807.svg";